/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Signupsuccess2Inputs */

const zh_auth_signupsuccess2 = /** @type {(inputs: Auth_Signupsuccess2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`账户创建成功`)
};

const en_auth_signupsuccess2 = /** @type {(inputs: Auth_Signupsuccess2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Account created successfully`)
};

const es_auth_signupsuccess2 = /** @type {(inputs: Auth_Signupsuccess2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuenta creada correctamente`)
};

/**
* | output |
* | --- |
* | "Account created successfully" |
*
* @param {Auth_Signupsuccess2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const auth_signupsuccess2 = /** @type {((inputs?: Auth_Signupsuccess2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Signupsuccess2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_auth_signupsuccess2(inputs)
	if (locale === "en") return en_auth_signupsuccess2(inputs)
	return es_auth_signupsuccess2(inputs)
});
export { auth_signupsuccess2 as "auth_signUpSuccess" }